<template>
    <div class="loading" v-if="!chatStore.isLoadedUser">
      در حال بارگذاری...
    </div>
    <div class="user-list" v-else-if="chatStore.cardsUser.length>0">
        <CardsChatUser v-for="user in chatStore.cardsUser" :key="user.user_account_id"
        :class="['user-item', chatStore.userSelectedId == user.user_account_id ? 'selected' : '']"
        :data="user" @click="select(user)" />
        <div ref="el" v-if="chatStore.hasMoreUser"></div>
    </div>
</template>
<script setup>
import { useTemplateRef } from 'vue'
import router from '@/router'
import { useInfiniteScroll } from '@vueuse/core'
import { polling } from '@/composables/polling'
import CardsChatUser from '../cards/CardsChatUser.vue';
import { isDefrentChatUserData } from '@/composables/polling/chat/isDefrentChatUserData'
import { useChatStore } from '@/stores/chat';
import { useAlertStore } from '@/stores/alert'
const alertStore = useAlertStore()
const chatStore = useChatStore()
const el = useTemplateRef('el')
polling( 
    async () => await chatStore.fetchChatUsers(chatStore.cardsUser.length > 0 ? chatStore.cardsUser.length : 10 , 0 , false),
    {
        oldData:chatStore.cardsUser??[],
        intervalMs: 6000,
        isDifferent: (newData) => isDefrentChatUserData(chatStore.cardsUser,newData),
        onChange: (allNewProduct) => {
            if(isDefrentChatUserData(chatStore && chatStore.cardsUser?chatStore.cardsUser:[],allNewProduct?allNewProduct:[])){
                if(chatStore.cardsUser.length<allNewProduct.length){
                    alertStore.type=true
                    alertStore.msg='تغییرات جدید!'
                }
                chatStore.cardsUser = allNewProduct?allNewProduct:[]
            }
        }
    }
)
useInfiniteScroll(
    el, 
    async () => {
        await chatStore.fetchChatUsers(10,chatStore.cardsUser.length,true) 
    } , { 
        distance: 50,
        canLoadMore: () => { 
            return chatStore.hasMoreUser
        } 
    }
)
const select = async (user) => {
    router.push({path:'/show-chat-user/'+user?.user_account_id})
}
</script>
 
<style scoped>
    .user-list {
        width: 100%;
        box-sizing: border-box;
        background-color: #f1dfdf82;
        display: flex;
        gap: 10px;
        padding: 2px;
        height: 100%;
        flex-direction: column;
        align-items: center;
    }
    .user-item{
        direction: rtl;
        width: 100%;
        box-sizing: border-box;
        height: 60px;
        display: flex;
        justify-content: space-evenly;
        flex-direction: row;
        flex-wrap: nowrap;
        box-shadow: 1px 0px 10px chartreuse;
        align-items: center;
        cursor: pointer;
        border-radius: 6px;
    }
    .user-item:hover {
        background: #f3f3f3;
    }
    .selected {
        background: #e0f2ff;
    }
</style>
